(function () {
  'use strict';

  var lifecycle = {
    attempts: 0,
    mount: null,
    observer: null,
    renderTimer: null,
    retryTimer: null,
    token: 0
  };
  var maxAttempts = 160;
  var retryDelay = 50;
  var renderTimeout = 12000;
  var mountObserver = null;
  var preloadedFilterBase = null;

  function preloadFilterModules() {
    var integration = window.boostWidgetIntegration;
    var assets = integration && integration.config && integration.config.assetFilesLoader;
    var script = assets && assets.mainScript && assets.mainScript.element;
    var base;

    script = script || document.querySelector('script[src*="/widget-integration/"][src*="/bc-widget-integration.js"]');
    if (!script) return;
    try {
      base = new URL(script.src, document.baseURI);
    } catch (error) {
      return;
    }
    if (!/^https?:$/.test(base.protocol) || !/\/widget-integration\/[^/]+\/bc-widget-integration\.js$/.test(base.pathname)) return;
    base = new URL('./', base);
    if (preloadedFilterBase === base.href) return;

    ['filter.module.js', 'instant-search.module.js'].forEach(function (name) {
      var url = new URL(name, base).href;
      var resources = document.querySelectorAll('link[rel="preload"][as="script"], script[src]');
      var index;
      var link;

      for (index = 0; index < resources.length; index += 1) {
        if ((resources[index].href || resources[index].src) === url) return;
      }

      link = document.createElement('link');
      link.rel = 'preload';
      link.setAttribute('as', 'script');
      link.setAttribute('fetchpriority', 'low');
      link.href = url;
      document.head.appendChild(link);
    });
    preloadedFilterBase = base.href;
  }

  function findMount(root) {
    var scope = root && root.querySelector ? root : document;

    if (scope.matches && scope.matches('[data-dw-boost-results]')) return scope;
    return scope.querySelector('[data-dw-boost-results]');
  }

  function getShell(mount) {
    return mount && mount.closest('[data-dw-boost-shell]');
  }

  function renderEmptySearch(mount) {
    var shell = getShell(mount);
    var template = shell && shell.querySelector('template[data-dw-search-empty-template]');
    var list = mount && mount.querySelector('.boost-sd__product-list[data-product-price="true"]');

    if (!template || !list || !mount.classList.contains('boost-sd__filter-product-list--ready')) return;
    if (mount.querySelector('.boost-sd__product-item, .boost-sd__product-item-list-view-layout, .boost-sd__no-search-result-page, .boost-sd__product-list-pagination-in-collection-search-empty-message')) return;

    list.appendChild(template.content.cloneNode(true));
  }

  function hasBoostOutput(mount) {
    renderEmptySearch(mount);
    return Boolean(
      mount && mount.querySelector('.boost-sd__product-item a[href*="/products/"], .boost-sd__no-search-result-page, .boost-sd__product-list-pagination-in-collection-search-empty-message')
    );
  }

  function clearLifecycleWatch() {
    if (lifecycle.retryTimer) window.clearTimeout(lifecycle.retryTimer);
    if (lifecycle.renderTimer) window.clearTimeout(lifecycle.renderTimer);
    if (lifecycle.observer) lifecycle.observer.disconnect();

    lifecycle.retryTimer = null;
    lifecycle.renderTimer = null;
    lifecycle.observer = null;
  }

  function setState(mount, state) {
    var shell = getShell(mount);
    var loading = shell && shell.querySelector('[data-dw-boost-loading]');
    var error = shell && shell.querySelector('[data-dw-boost-error]');
    var initial = shell && shell.querySelector('[data-dw-collection-initial]');

    document.documentElement.dataset.dwBoostRender = state;
    document.documentElement.dataset.dwBoostLifecycle = state;
    if (!shell) return;

    shell.dataset.dwBoostState = state;
    shell.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    if (state === 'ready' && initial) {
      initial.remove();
      delete shell.dataset.dwInitialProducts;
    }
    if (loading) loading.hidden = state !== 'loading' || Boolean(initial && !initial.hidden);
    if (error) error.hidden = state !== 'error';
    mount.hidden = state === 'error';
  }

  function markReady(mount, token) {
    if (token !== lifecycle.token || !hasBoostOutput(mount)) return false;

    clearLifecycleWatch();
    mount.setAttribute('data-dw-boost-init', 'ready');
    setState(mount, 'ready');
    return true;
  }

  function markError(mount, token) {
    if (token !== lifecycle.token) return;
    if (markReady(mount, token)) return;

    clearLifecycleWatch();
    mount.setAttribute('data-dw-boost-init', 'error');
    setState(mount, 'error');
  }

  function watchRender(mount, token) {
    if (markReady(mount, token)) return;

    lifecycle.observer = new MutationObserver(function () {
      markReady(mount, token);
    });
    lifecycle.observer.observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-product-price'] });

    lifecycle.renderTimer = window.setTimeout(function () {
      if (!markReady(mount, token)) markError(mount, token);
    }, renderTimeout);
  }

  function requestRender(mount, token) {
    var boostUtils;
    var result;

    if (token !== lifecycle.token || !mount.isConnected) return;
    if (markReady(mount, token)) return;

    preloadFilterModules();

    boostUtils = window.boostSDTaeUtils;
    if (boostUtils && typeof boostUtils.initCollectionFilter === 'function') {
      mount.setAttribute('data-dw-boost-init', 'requested');
      watchRender(mount, token);

      try {
        result = boostUtils.initCollectionFilter();
        if (result && typeof result.catch === 'function') {
          result.catch(function () { markError(mount, token); });
        }
      } catch (error) {
        markError(mount, token);
      }
      return;
    }

    lifecycle.attempts += 1;
    if (lifecycle.attempts >= maxAttempts) {
      markError(mount, token);
      return;
    }

    lifecycle.retryTimer = window.setTimeout(function () {
      requestRender(mount, token);
    }, retryDelay);
  }

  function initialise(root, force) {
    var mount = findMount(root);
    var token;

    if (!mount) return;
    if (mountObserver) {
      mountObserver.disconnect();
      mountObserver = null;
    }
    if (!force && hasBoostOutput(mount)) {
      clearLifecycleWatch();
      lifecycle.mount = mount;
      lifecycle.token += 1;
      mount.setAttribute('data-dw-boost-init', 'ready');
      setState(mount, 'ready');
      return;
    }
    if (!force && lifecycle.mount === mount && (lifecycle.retryTimer || mount.getAttribute('data-dw-boost-init') === 'requested')) {
      return;
    }

    clearLifecycleWatch();
    lifecycle.mount = mount;
    lifecycle.attempts = 0;
    lifecycle.token += 1;
    token = lifecycle.token;

    if (force) {
      mount.innerHTML = '';
      mount.classList.remove('boost-sd__filter-product-list--ready');
    }
    mount.removeAttribute('data-dw-boost-init');
    setState(mount, 'loading');
    requestRender(mount, token);
  }

  function handleRetry(event) {
    var button = event.target && event.target.closest
      ? event.target.closest('[data-dw-boost-retry]')
      : null;
    var shell;

    if (!button) return;

    shell = button.closest('[data-dw-boost-shell]');
    initialise(shell || document, true);
  }

  document.addEventListener('click', handleRetry);
  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target, true);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) initialise(document, false);
  });

  if (findMount(document)) {
    initialise(document, false);
  } else if (document.readyState === 'loading') {
    mountObserver = new MutationObserver(function (mutations) {
      for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
        var nodes = mutations[mutationIndex].addedNodes;
        for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
          if (nodes[nodeIndex].nodeType !== 1) continue;
          var mount = findMount(nodes[nodeIndex]);
          if (mount) {
            initialise(mount, false);
            return;
          }
        }
      }
    });
    mountObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', function () {
      if (mountObserver) {
        mountObserver.disconnect();
        mountObserver = null;
      }
      initialise(document, false);
    }, { once: true });
  }
}());
